import { DateTime } from "luxon";
import type { NetztransparenzMissingValue } from "../NetztransparenzValuesError";

function formatMissingPeriods(periods: NetztransparenzMissingValue["periods"]) {
  // Group periods by year and collect all months for each year
  const periodsByYear = periods.reduce(
    (acc, period) => {
      const year = period.year;

      if (!acc[year]) {
        acc[year] = {
          year,
          months: []
        };
      }

      if (period.months && period.months.length > 0) {
        // Add months and remove duplicates
        acc[year].months = [
          ...new Set([...acc[year].months, ...period.months])
        ];
      }

      return acc;
    },
    {} as Record<number, { year: number; months: number[] }>
  );

  // Convert back to array and sort by year
  const groupedPeriods = Object.values(periodsByYear).sort(
    (a, b) => a.year - b.year
  );

  return groupedPeriods
    .map((p) => {
      if (p.months && p.months.length > 0) {
        // Sort months chronologically
        const sortedMonths = p.months.sort((a, b) => a - b);
        const months = sortedMonths
          .map((m) =>
            DateTime.fromObject({ month: m }).toLocaleString({ month: "long" })
          )
          .join(", ");
        return `${months} ${p.year}`;
      }
      return `${p.year}`;
    })
    .join(", ");
}

export { formatMissingPeriods };
